import { Component, Input, OnInit } from '@angular/core';
import { StatusBadgeColourScheme } from '../status-badge-constants';
import { appConstants } from '../../../../shared/constants/app-constants';

@Component({
  selector: 'app-committee-status-badge',
  standalone: false,
  templateUrl: './committee-status-badge.component.html',
  styleUrl: './committee-status-badge.component.scss'
})
export class CommitteeStatusBadgeComponent implements OnInit {
  @Input() name: string = 'committee-status-badge';
  @Input() committeeStatus?: string | null = '';
  badgeColourScheme: StatusBadgeColourScheme = StatusBadgeColourScheme.grey;


  ngOnInit(): void {
    this.badgeColourScheme = this.getBadgeColourScheme();
  }

  private getBadgeColourScheme(): StatusBadgeColourScheme {
    switch (this.committeeStatus?.toLowerCase()) {
      case appConstants.committeeStatus.active.toLowerCase():
        return StatusBadgeColourScheme.Green;
      case appConstants.committeeStatus.inactive.toLowerCase():
        return StatusBadgeColourScheme.Red;
      case appConstants.committeeStatus.disbanded.toLowerCase():
        return StatusBadgeColourScheme.Red;
      default:
        return StatusBadgeColourScheme.grey;
    }
  }

}
